import { moveUserFiles } from '..';
export const cbForMove = (destinationPath, destinationRepository, configParams) => (sources) => moveUserFiles(destinationRepository, sources, destinationPath, configParams);
